import NotificationCountActionTypes from './NotificationCountActionTypes';
import NotificationCountDispatcher from './NotificationCountDispatcher';

const Actions = {
  refreshNotificationCount() {
    NotificationCountDispatcher.dispatch({
      type: NotificationCountActionTypes.REFRESH_NOTIFICATION_COUNT,
    });
  }
};

export default Actions



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/NotificationCountActions.js